import { clsx } from 'clsx';

import ReactPlayer from 'react-player/youtube';

// Only loads the YouTube player

import { IProps } from './types';
import * as S from './styles';

export const VideoPlayer: React.FC<IProps> = ({ image, video }: IProps) => (
  <S.Wrapper
    className={clsx('video', {
      landscaped: image?.dimensions?.width >= image?.dimensions?.height,
      portrait: image?.dimensions?.width < image?.dimensions?.height,
    })}
  >
    {video && (
      <ReactPlayer
        className="react-player"
        url={video?.embed_url}
        width="100%"
        height="100%"
      />
    )}
  </S.Wrapper>
);
